import React from 'react';
import { PropTypes } from 'prop-types';

import PaymentDataForm from 'components/PaymentData/PaymentDataForm';

const PaymentData = ({
  className,
  country,
  fullPrice,
  hasQuoteError,
  isSubmitting,
  hasPastError,
  hasErrors,
  paymentData,
  t,
  submitPaymentData,
}) => (
  <div className={className}>
    <PaymentDataForm
      country={country}
      fullPrice={fullPrice}
      hasQuoteError={hasQuoteError}
      isSubmitting={isSubmitting}
      hasPastError={hasPastError}
      hasErrors={hasErrors}
      paymentData={paymentData}
      t={t}
      handleSubmit={submitPaymentData}
    />
  </div>
);

PaymentData.propTypes = {
  country: PropTypes.string,
  className: PropTypes.string,
  t: PropTypes.func,
  fullPrice: PropTypes.number,
  isSubmitting: PropTypes.bool,
  hasPastError: PropTypes.bool,
  hasQuoteError: PropTypes.bool,
  hasErrors: PropTypes.bool,
  paymentData: PropTypes.string.isRequired,
  submitPaymentData: PropTypes.func,
};

PaymentData.defaultProps = {
  country: '',
  className: '',
  t: (t) => t,
  fullPrice: 0,
  isSubmitting: false,
  hasPastError: false,
  hasQuoteError: false,
  hasErrors: false,
  submitPaymentData: () => ({}),
};

export default PaymentData;
